import { useState, useEffect } from "react";
import {
  ButtonComponent,
  trans,
  HeaderComponent,
} from "@comps/components";
import { makeRequest } from "@utils/helpers";
import { Commons, Const } from "../constants";
import { message } from 'antd';
import { FilterComponentCopy, FilterButton, PaginationComponent } from "@comps/components";
import { downloadSalarySheetReq, downloadSalarySheetPdfReq, getAllDataReq, getFilterReq, downloadDepartmentSalarySheetReq, downloadDisbursementRegisterReq } from "./requests";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import { handleDownloadFile } from "@utils/helpers";
import { Spin } from 'antd';

const langKey = Const["salarySheets"].lngKey;
const pageConfig = {
  headers: {
    title: trans(`${langKey}.moduleName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.moduleName`),
        path: Const["salarySheets"].route
      }
    ]
  }
}
//global variables
var col_span_for_employee = 0;
var col_span_for_deduction = 0;
var col_span_for_earning = 0;
var col_span_for_benefit = 0;
var col_span_for_reimbursement = 0;
var filters = '';
const payitemTheme = {
  benefit: {
    sectionClass: "salary-sheet__group--benefit",
    headerClass: "salary-sheet__header--benefit",
  },
  earning: {
    sectionClass: "salary-sheet__group--earning",
    headerClass: "salary-sheet__header--earning",
  },
  deduction: {
    sectionClass: "salary-sheet__group--deduction",
    headerClass: "salary-sheet__header--deduction",
  },
  reimbursement: {
    sectionClass: "salary-sheet__group--reimbursement",
    headerClass: "salary-sheet__header--reimbursement",
  },
  totals: {
    sectionClass: "salary-sheet__group--totals",
    headerClass: "salary-sheet__header--totals",
  }
};

const formatAmount = (value) => {
  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) {
    return value;
  }

  return numericValue.toFixed(2);
};

const getPayitemCount = (payitems = {}) => (
  ['benefit', 'earning', 'deduction', 'reimbursement']
    .reduce((count, key) => count + (payitems[key]?.length || 0), 0)
);

const IndexSalarySheets = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);

  // const [filters, setFilters] = useState();
  const [loading, setLoading] = useState(false)
  const [payitems, setPayitems] = useState({})
  const [showExited, setShowExited] = useState(false)
  const [selectedFilters, setSelectedFilters] = useState(props.initialFilters || '')
  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState({
    "total": 0,
    "count": 0,
    "per_page": 0,
    "current_page": 0,
    "total_pages": 0,
    "links": {}
  });

  // ==================================
  //   Use States End
  // ==================================

  // ==================================
  //   Table Data End
  // ==================================
  // ==================================
  //   Table Data End
  // ==================================

  useEffect(() => {
    if (props.embedded && props.initialFilters) {
      filters = props.initialFilters;
      setSelectedFilters(props.initialFilters);
      getAllData(props.initialFilters);
    }
    // eslint-disable-next-line
  }, [props.embedded, props.initialFilters]);

  useEffect(() => {
    getAllData(filters)
    // eslint-disable-next-line
  }, [currentPage]);

  const getAllData = (fil) => {

    if (!fil) {
      if (!props.embedded) {
        onOpenFilter()
      }
      return
    }
    setLoading(true)
    filters = fil
    setSelectedFilters(fil)
    setChildComponent(null)
    const payload = {
      page: currentPage,
      filters: filters
    }
    makeRequest(setLoader, getAllDataReq, payload, onSuccess, onGetAllDataError);
    onCloseFilter()
  };

  const onSuccess = (data, response) => {
    setPayitems(response.data.payitems)
    setShowExited(!!response.data.show_exited)
    setDataSource(response.data.employments.data);
    setPagination(response.data.employments)
    if (response.data.employments.data.length < 1) {
      message.info('Salary Not Found with given filters');
      onOpenFilter();
      setLoading(false)
      return
    }
    if (response.message !== undefined) {

    }
    setLoading(false)
    onCloseFilter()
  };
  const onGetAllDataError = (err, res) => {
    setLoading(false)
    message.error(res.response.data.message);
    onCloseFilter()
  }

  const onDownload = (type) => {
    setLoading(true)
    const payload = {
      filters: `${filters};download_type_|${type};`,
    }
    makeRequest(setLoader, downloadSalarySheetReq, payload, onDownloadSuccess, onDownloadSuccess);
    //makeRequestStateless(downloadSalarySheetReq, payload, onDownloadSuccess, onDownloadSuccess);
  }
  const onDownloadPdf = () => {
    setLoading(true)
    const payload = {
      filters: `${filters};`,
    }
    makeRequest(setLoader, downloadSalarySheetPdfReq, payload, onDownloadSuccess, onDownloadSuccess);
  }
  const onDownloadDepartmentWise = (type) => {
    setLoading(true)
    const payload = {
      filters: `${filters};download_type_|${type};`,
    }
    makeRequest(setLoader, downloadDepartmentSalarySheetReq, payload, onDownloadSuccess, onDownloadSuccess);
    //makeRequestStateless(downloadSalarySheetReq, payload, onDownloadSuccess, onDownloadSuccess);
  }
  const onDownloadRegister = () => {
    setLoading(true)
    const match = (filters || '').match(/month_\|([0-9-]+)/)
    const month = match ? match[1] : ''
    makeRequest(setLoader, downloadDisbursementRegisterReq, { month }, onDownloadRegisterSuccess, onDownloadRegisterSuccess);
  }
  const onDownloadRegisterSuccess = (err, res) => {
    setLoading(false)
    if (res.code === undefined) {
      handleDownloadFile('DisbursementRegister.xlsx', res)
    } else {
      message.error(res.message)
    }
  }

  const onDownloadSuccess = (err, res) => {
    setLoading(false)
    if (res.code === undefined) {
      const fileExtension = res.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? 'xlsx' : 'pdf'
      const fileName = `SalarySheet.${fileExtension}`
      handleDownloadFile(fileName, res)
    }
    else {
      message.error(res.message)
    }
  }

  //---------------filters-----------------------
  const onOpenFilter = () => {
    setChildComponent(<FilterComponentCopy filters={ filterFields } modkey={ props.modkey } selected={ selectedFilters } api={ getFilterReq } setCurrentPage={ setCurrentPage } onFilter={ onFilter } onCloseFilter={ onCloseFilter }
    />
    )
  }

  const onFilter = (filters) => {
    getAllData(filters)
  }
  const onCloseFilter = () => {
    setChildComponent(null);
  }
  //----end filter--------------------
  //get payitems
  const getPayitems = (each) => {
    col_span_for_benefit = payitems.benefit ? payitems.benefit.length : 0;
    col_span_for_earning = payitems.earning ? payitems.earning.length : 0;
    col_span_for_deduction = payitems.deduction ? payitems.deduction.length : 0;
    var html = employment(each);

    var benefits = 0;
    if (payitems.benefit) {
      col_span_for_benefit = payitems.benefit.length;
      payitems.benefit.forEach(function (row) {
        var payitem = each.computed[row.id];
        if (payitem) {
          benefits += payitem.amount;
          html += getTd(payitem.amount);
        } else {
          html += getTd("-");
        }
      });

      col_span_for_benefit++;
      if (each.cpl) {
        html += getTd(each.cpl);
      } else {
        html += getTd("-");
      }
    }

    var earnings = 0;
    if (payitems.earning) {
      col_span_for_earning = payitems.earning.length;
      payitems.earning.forEach(function (row) {
        var payitem = each.computed[row.id];
        if (payitem) {
          earnings += payitem.amount;
          html += getTd(payitem.amount);
        } else {
          html += getTd("-");
        }
      });

      col_span_for_earning++;
      if (each.cpl) {
        html += getTd(each.cpl);
      } else {
        html += getTd("-");
      }
    }


    var deductions = 0;
    if (payitems.deduction) {
      col_span_for_deduction = payitems.deduction.length;
      payitems.deduction.forEach(function (row) {
        var payitem = each.computed[row.id];
        if (payitem) {
          deductions += payitem.amount;
          if (payitem.details) {
            html += getTd(payitem.details);
          } else {
            html += getTd(payitem.amount);
          }
        } else {
          html += getTd("-");
        }
      });

      col_span_for_deduction++;
      if (each.quota) {
        html += getTd(each.quota);
      } else {
        html += getTd("-");
      }
    }
    var reimbursements = 0;
    if (payitems.reimbursement) {
      col_span_for_reimbursement = payitems.reimbursement.length;
      payitems.reimbursement.forEach(function (row) {
        var payitem = each.computed[row.id];
        if (payitem) {
          reimbursements += payitem.amount;
          html += getTd(payitem.details);
        } else {
          html += getTd("-");
        }
      });
    }
    html += total(each, earnings, deductions, reimbursements, benefits);
    return html;
  };
  //get emplpoyee info
  function employment(each) {
    col_span_for_employee = 1;
    var html = '<td class="salary-sheet__employee-cell"><div class="salary-sheet__employee-identity">';
    if (each.profile_pic_url === "images/arnold-avatar.jpg") {
      each.profile_pic_url = '/images/arnold-avatar.jpg'
    }
    html += '<img width="40" height="40" class="salary-sheet__employee-avatar thumb img-circle rounded-circle" src="' + each.profile_pic_url + '" alt="' + each.full_name_code + '"/> ';
    html += '<div class="salary-sheet__employee-copy"><strong>' + each.full_name_code + '</strong>';
    html += '<span>' + each.designation_name + '</span></div>';
    html += "</div></td>";

    col_span_for_employee++;
    html += '<td class="salary-sheet__meta-cell">';
    html += each.branch_name;
    html += "</td>";

    col_span_for_employee++;
    html += '<td class="salary-sheet__meta-cell">';
    html += each.department_name;
    html += "</td>";

    col_span_for_employee++;
    html += '<td class="salary-sheet__meta-cell">';
    html += each.designation_name;
    html += "</td>";

    col_span_for_employee++;
    html += '<td class="salary-sheet__amount-cell salary-sheet__amount-cell--strong">';
    html += formatAmount(each.actual_salary);
    html += "</td>";

    // col_span_for_employee++;
    // html += "<td>";
    // html += each.no_of_days;
    // html += "</td>";

    // col_span_for_employee++;
    // html += "<td>";
    // html += each.worked_minutes + "minutes";
    // html += "</td>";
    col_span_for_employee++;
    html += '<td class="salary-sheet__status-cell"><span class="salary-sheet__status-badge label ' + each.payslip_class + '">';
    html += each.payslip_status;
    html += "</span></td>";

    if (showExited) {
      col_span_for_employee++;
      html += '<td class="salary-sheet__status-cell"><span class="salary-sheet__status-badge label ' + (each.employment_status_class || 'bg-secondary') + '">';
      html += (each.employment_status || '');
      html += "</span>";
      if (each.last_working_date) {
        html += '<div style="font-size:10px;color:#64748b;margin-top:2px;">LWD: ' + each.last_working_date + '</div>';
      }
      html += "</td>";
    }

    return html;
  }

  // get td columns
  function getTd(amount) {

    if (Array.isArray(amount)) {
      var html = '<td class="salary-sheet__details-cell">';
      var total = 0;
      amount.forEach(function (row) {
        total += row.amount;
        html += '<div class="salary-sheet__detail-line"><span>' + row.name + '</span><strong>' + formatAmount(row.amount) + '</strong></div>';
      });
      html += '<div class="salary-sheet__detail-total"><span>Total</span><strong>' + formatAmount(total) + '</strong></div>';
      html += "</td>";
      if (total) {
        return html;
      }
      return '<td class="salary-sheet__amount-cell">0.00</td>';
    }
    if (amount === "-") {
      return '<td class="salary-sheet__empty-cell">' + amount + "</td>";
    }
    return '<td class="salary-sheet__amount-cell">' + formatAmount(amount) + "</td>";
  }

  //get total 
  function total(each, earnings, deductions, reimbursement, benefits) {
    var html = "";
    html += getTd(benefits);
    html += getTd(earnings);
    html += getTd(deductions);
    html += getTd(reimbursement);
    html += getTd(each.cash_salary);
    html += getTd(each.bank_salary);

    return html;
  }
  //
  return (
    <>

      { childComponent }
      { props.embedded && (
        <div style={ { display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 12, flexWrap: "wrap" } }>
          <ButtonComponent text='PDF' icon={ <FilePdfOutlined className='text-danger' /> } type='primary' onClick={ onDownloadPdf } disabled={ dataSource.length < 1 } />
          <ButtonComponent text='EXCEL' icon={ <FileExcelOutlined className='text-success bg-light' /> } type='primary' onClick={ () => onDownload('xlsx') } disabled={ dataSource.length < 1 } />
          <ButtonComponent text='Department Wise' icon={ <FileExcelOutlined className='text-success bg-light' /> } type='primary' onClick={ () => onDownloadDepartmentWise('xlsx') } disabled={ dataSource.length < 1 } />
          <ButtonComponent text='Disbursement Register' icon={ <FileExcelOutlined className='text-success bg-light' /> } type='primary' onClick={ onDownloadRegister } disabled={ dataSource.length < 1 } />
          <ButtonComponent text='Refresh' type='primary' onClick={ () => getAllData(selectedFilters !== undefined ? selectedFilters : '') } />
          <FilterButton onClick={ onOpenFilter } />
        </div>
      ) }
      { !props.embedded && (
        <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>
          <ButtonComponent text='PDF' icon={ <FilePdfOutlined className='text-danger' /> } type='primary' onClick={ onDownloadPdf } disabled={ dataSource.length < 1 } />
          <ButtonComponent text='EXCEL' icon={ <FileExcelOutlined className='text-success bg-light' /> } type='primary' onClick={ () => onDownload('xlsx') } disabled={ dataSource.length < 1 } />
          <ButtonComponent text='Department Wise' icon={ <FileExcelOutlined className='text-success bg-light' /> } type='primary' onClick={ () => onDownloadDepartmentWise('xlsx') } disabled={ dataSource.length < 1 } />
          <ButtonComponent text='Disbursement Register' icon={ <FileExcelOutlined className='text-success bg-light' /> } type='primary' onClick={ onDownloadRegister } disabled={ dataSource.length < 1 } />

          <ButtonComponent text='Refresh' type='primary' onClick={ () => getAllData(filters !== undefined ? filters : '') } />
          <FilterButton onClick={ onOpenFilter } />

        </HeaderComponent>
      ) }
      <Spin spinning={ loading }>
        {
          selectedFilters && dataSource.length > 0 &&
          <>
            {/* <div className="salary-sheet__summary">
              <div className="salary-sheet__summary-card">
                <span className="salary-sheet__summary-label">{ trans(Commons.employee) }</span>
                <strong className="salary-sheet__summary-value">{ dataSource.length }</strong>
              </div>
              <div className="salary-sheet__summary-card">
                <span className="salary-sheet__summary-label">Pay Items</span>
                <strong className="salary-sheet__summary-value">{ getPayitemCount(payitems) }</strong>
              </div>
              <div className="salary-sheet__summary-card">
                <span className="salary-sheet__summary-label">{ trans(`${langKey}.totals`) }</span>
                <strong className="salary-sheet__summary-value">6 payout columns</strong>
              </div>
            </div> */}
            <div className="basetable-salarysheet-container salary-sheet__table-shell" style={ { marginTop: '20px' } }>
              <table className="table table-bordered table-responsive salary-sheet__table">
                <thead>
                  <tr className="group">
                    <th className="text-center salary-sheet__group salary-sheet__group--employee" colSpan={ col_span_for_employee }>{ trans(Commons.employee) }</th>

                    {
                      payitems.benefit &&
                      <th className={ `text-center salary-sheet__group ${payitemTheme.benefit.sectionClass}` } colSpan={ col_span_for_benefit }>
                        <strong>{ trans(`${langKey}.benefits`) }</strong>
                      </th>
                    }
                    {
                      payitems.earning &&
                      <th className={ `text-center salary-sheet__group ${payitemTheme.earning.sectionClass}` } colSpan={ col_span_for_earning }>
                        <strong>{ trans(`${langKey}.earnings`) }</strong>
                      </th>
                    }
                    {
                      payitems.deduction &&
                      <th className={ `text-center salary-sheet__group ${payitemTheme.deduction.sectionClass}` } colSpan={ col_span_for_deduction }>
                        <strong>{ trans(`${langKey}.deductions`) }</strong>
                      </th>
                    }
                    {
                      payitems.reimbursement &&
                      <th className={ `text-center salary-sheet__group ${payitemTheme.reimbursement.sectionClass}` } colSpan={ col_span_for_reimbursement }>
                        <strong>{ trans(`${langKey}.reimbursements`) }</strong>
                      </th>
                    }

                    <th className={ `text-center salary-sheet__group ${payitemTheme.totals.sectionClass}` } colSpan="6"><strong>{ trans(`${langKey}.totals`) }</strong></th>

                  </tr>
                  <tr>
                    <th className="w-100 salary-sheet__header salary-sheet__header--employee" style={ {
                      minWidth: '350px'
                    } } >{ trans(Commons.employee) }</th>
                    <th className="salary-sheet__header salary-sheet__header--employee">{ trans(Commons.branch) }</th>
                    <th className="salary-sheet__header salary-sheet__header--employee">{ trans(Commons.department) }</th>
                    <th className="salary-sheet__header salary-sheet__header--employee">{ trans(Commons.designation) }</th>
                    <th className="salary-sheet__header salary-sheet__header--employee" style={ {
                      minWidth: '150px'
                    } } >{ trans(`${langKey}.actual_salary`) }</th>
                    {/* <th>DAYS</th>
              <th>WORKING_HOURS</th> */}
                    <th className="salary-sheet__header salary-sheet__header--employee" style={ {
                      minWidth: '150px'
                    } }>{ trans(`${langKey}.status`) }</th>
                    { showExited &&
                      <th className="salary-sheet__header salary-sheet__header--employee" style={ {
                        minWidth: '150px'
                      } }>{ trans(`${langKey}.employmentStatus`) }</th>
                    }

                    { payitems.benefit !== undefined && payitems.benefit.map(payitem => (
                      <th key={ `benefit-${payitem.id}` } className={ `salary-sheet__header ${payitemTheme.benefit.headerClass}` } style={ {
                        minWidth: '200px'
                      } }>{ payitem.name }</th>
                    )) }

                    { payitems.benefit !== undefined &&
                      <th className={ `salary-sheet__header ${payitemTheme.benefit.headerClass}` }>CPL</th>
                    }
                    { payitems.earning !== undefined && payitems.earning.map(payitem => (
                      <th key={ `earning-${payitem.id}` } className={ `salary-sheet__header ${payitemTheme.earning.headerClass}` } style={ {
                        minWidth: '200px'
                      } }>{ payitem.name }</th>
                    )) }

                    { payitems.earning !== undefined &&

                      <th className={ `salary-sheet__header ${payitemTheme.earning.headerClass}` }>{ trans(`${langKey}.cpl`) }</th>
                    }
                    { payitems.deduction !== undefined && payitems.deduction.map(payitem => (
                      <th key={ `deduction-${payitem.id}` } className={ `salary-sheet__header ${payitemTheme.deduction.headerClass}` } style={ {
                        minWidth: '250px'
                      } }>{ payitem.name }</th>
                    )) }

                    {
                      payitems.deduction && <th className={ `salary-sheet__header ${payitemTheme.deduction.headerClass}` }>{ trans(`${langKey}.quota`) }</th>
                    }

                    { payitems.reimbursement !== undefined && payitems.reimbursement.map(payitem => (
                      <th key={ `reimbursement-${payitem.id}` } className={ `salary-sheet__header ${payitemTheme.reimbursement.headerClass}` }>{ payitem.name }</th>
                    )) }
                    <th className={ `salary-sheet__header ${payitemTheme.totals.headerClass}` } style={ {
                      minWidth: '150px'
                    } }>{ "Total Benefits" }</th>
                    <th className={ `salary-sheet__header ${payitemTheme.totals.headerClass}` } style={ {
                      minWidth: '150px'
                    } }>{ trans(`${langKey}.total_earnings`) }</th>
                    <th className={ `salary-sheet__header ${payitemTheme.totals.headerClass}` } style={ {
                      minWidth: '150px'
                    } }>{ trans(`${langKey}.total_deductions`) }</th>
                    <th className={ `salary-sheet__header ${payitemTheme.totals.headerClass}` }>{ trans(`${langKey}.reimbursements`) }</th>
                    {/* <th>{ trans(`${langKey}.net_pay`) }</th> */ }
                    <th className={ `salary-sheet__header ${payitemTheme.totals.headerClass}` }>{ "Net Cash" }</th>
                    <th className={ `salary-sheet__header ${payitemTheme.totals.headerClass}` }>{ "Net Bank" }</th>
                  </tr>
                </thead>
                <tbody>
                  { dataSource.length > 0 && dataSource.map(each => (
                    <tr key={ each.id || each.employee_id || each.full_name_code } dangerouslySetInnerHTML={ { __html: getPayitems(each) } } />
                  )) }

                </tbody>
              </table>

            </div>
          </>
        }
      </Spin>
      { selectedFilters && dataSource.length > 0 && <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } /> }
    </>
  );
};

export default IndexSalarySheets;
const filterFields = [

  {
    type: "select",
    placeholder: 'Location',
    key: "location",
    data_key: "organization_structure_data.location",
  },
  {
    type: "select",
    placeholder: 'Branch',
    key: "branch",
    data_key: "organization_structure_data.branch",

  },
  {
    type: "select",
    placeholder: 'Departments',
    key: "department",
    data_key: "organization_structure_data.department",
    filterKey: "hierarchy_code"
  },
  {
    type: "select",
    placeholder: 'Employee',
    key: "employees",
    data_key: "supporting_data.employees",
    resource_type: 'employment'
    //is_resource: true
  },
  {
    type: "select",
    placeholder: 'Payroll',
    key: "payroll",
    data_key: "supporting_data.payroll",
    required: true
    //is_resource: true
  },
  {
    type: "date",
    placeholder: "Month",
    key: "month",
    required: true
  },

]
